module.exports = __webpack_public_path__ + "static/media/Truck.da700dd5.svg";